"use client"

import { useConfigParams } from "@/hooks"
import {
  AnalyticsStore,
  AnalyticsStoreContext,
  createAnalyticsStore,
} from "@/store/analytics-store"
import useSignupRequestStore from "@/store/signup-request-store"
import { ReactNode, use, useRef } from "react"
import { useStore } from "zustand"

const AnalyticsProvider = ({ children }: { children?: ReactNode }) => {
  const storeRef = useRef<AnalyticsStore>(undefined)
  const { channel } = useConfigParams()
  const {
    data: { intcmpFromSearchParams },
  } = useSignupRequestStore()
  // eslint-disable-next-line react-hooks/refs
  if (!storeRef.current) {
    const userAgent =
      typeof window !== "undefined" ? window.navigator.userAgent : ""
    storeRef.current = createAnalyticsStore({
      site_id: channel,
      intcmp: intcmpFromSearchParams || "",
      operating_system: userAgent,
    })
  }

  return (
    // eslint-disable-next-line react-hooks/refs
    <AnalyticsStoreContext.Provider value={storeRef.current}>
      {children}
    </AnalyticsStoreContext.Provider>
  )
}

const useAnalyticsContext = () => {
  const analyticsStore = use(AnalyticsStoreContext)
  if (!analyticsStore)
    throw new Error("Missing AnalyticsStoreContext in the tree")

  const dataLayer = useStore(analyticsStore, (s) => s.dataLayer)
  const setData = useStore(analyticsStore, (s) => s.setData)
  const sendData = useStore(analyticsStore, (s) => s.sendData)

  return { dataLayer, setData, sendData }
}
export { AnalyticsProvider, useAnalyticsContext }
